const horseUrlBuilder = (id, name) => {
    if (id && name) {
        const replaceMap = {
            ' ': '-',
            '\'': '',
            '.': ''
        };

        const urlName = name.toLowerCase().replace(/ |'|./g, (matched) =>
            (typeof replaceMap[matched] !== 'undefined' ? replaceMap[matched] : matched)
        );

        return `/profile/horse/${id}/${urlName}`;
    }
    return null;
};

export default horseUrlBuilder;



// WEBPACK FOOTER //
// ./src/client/components/GriddleRP/urlBuilder.js